import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cover-thumbnail',
  templateUrl: './cover-thumbnail.component.html',
  standalone: false
})
export class CoverThumbnailComponent implements OnInit {
  @Input() id: any;
  @Input() color: any;
  @Input() option: any;
  @Input() height: any = 51;
  @Input() width: any = 38;

  constructor() {
  }

  ngOnInit() {
  }

}
